import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAirtable = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M17.8612 3.69119L2.94811 9.86244C2.11874 10.2062 2.12749 11.3837 2.96186 11.7143L17.9369 17.6531C19.2526 18.1749 20.718 18.1749 22.0337 17.6531L37.0087 11.7143C37.8431 11.3831 37.8525 10.2056 37.0225 9.86244L22.11 3.69181C20.7495 3.12877 19.2211 3.12877 17.8606 3.69181",
			fill: "#FFCC00"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.3143 20.8975V35.7331C21.3145 35.8961 21.3546 36.0565 21.4309 36.2005C21.5073 36.3444 21.6177 36.4675 21.7525 36.5591C21.8873 36.6506 22.0424 36.7079 22.2044 36.7258C22.3664 36.7437 22.5303 36.7217 22.6818 36.6619L39.3693 30.1844C39.5553 30.1104 39.7148 29.9824 39.8273 29.8168C39.9397 29.6512 39.9998 29.4557 40 29.2556V14.4206C39.9997 14.2576 39.9597 14.0972 39.8834 13.9533C39.807 13.8093 39.6966 13.6862 39.5618 13.5946C39.427 13.5031 39.2718 13.4458 39.1099 13.4279C38.9479 13.41 38.784 13.432 38.6325 13.4919L21.945 19.9694C21.759 20.0433 21.5994 20.1713 21.487 20.3369C21.3746 20.5025 21.3144 20.6973 21.3143 20.8975Z",
			fill: "#31C2F2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.4187 21.6596L11.9637 24.294L1.50936 29.3034C0.84686 29.6234 0.000610352 29.1409 0.000610352 28.4034V14.4796C0.000610352 14.2134 0.13686 13.9834 0.32061 13.8109C0.395719 13.736 0.480919 13.6721 0.573735 13.6209C0.823735 13.4709 1.17999 13.4309 1.48311 13.5509L17.3362 19.8321C18.1487 20.1521 18.2112 21.2809 17.4194 21.6602",
			fill: "#ED3049"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.4187 21.6609L12.4662 24.0521L0.319946 13.8109C0.395055 13.736 0.480254 13.6721 0.573071 13.6209C0.823071 13.4709 1.17932 13.4309 1.48245 13.5509L17.3356 19.8321C18.1481 20.1521 18.2106 21.2815 17.4187 21.6609Z",
			fill: "#C62842"
		})
	]
});
export default SvgAirtable;
